// Footer Page Components
import React from 'react';
import { useState } from 'react';
import styles from '../css/footerPage.module.css';
import { useNavigate } from 'react-router-dom';
import { FaHistory } from 'react-icons/fa';
import { HiOutlineDocumentReport } from 'react-icons/hi';
import { RiFindReplaceFill } from 'react-icons/ri';
import { Slide, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function FooterPage() {
  const navigate = useNavigate();
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <div>
      <ToastContainer position="top-center" transition={Slide} autoClose={3000} closeOnClick={true} />
      <div className={styles.buttonsContainer}>
        <div>
          <button
            className={styles.findButton}
            onClick={() => {
              navigate('/searchPage');
            }}
          >
            <RiFindReplaceFill
              style={{
                marginRight: '8px',
                position: 'relative',
                top: '3px',
              }}
              size={'15px'}
            />
            Find Ticket Location
          </button>
        </div>
        <div>
          <button
            className={styles.findButton}
            onMouseEnter={() => {
              setShowTooltip(true);
            }}
            onMouseLeave={() => {
              setShowTooltip(false);
            }}
            onClick={() => {
              navigate('/updatedDash');
              // toast.info(
              //   <div>
              //     <h3>Not implemented yet!</h3>
              //     <p>Feature coming soon!</p>
              //   </div>,
              //   {
              //     position: 'top-center',
              //     autoClose: 5000,
              //     closeOnClick: true,
              //     transition: Slide,
              //   },
              // );
            }}
          >
            <FaHistory
              style={{
                marginRight: '8px',
                position: 'relative',
                top: '3px',
              }}
              size={'15px'}
            />
            Show Today History
          </button>
          {showTooltip && (
            <div
              style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translateX(-50%)',
                background: 'black',
                color: 'white',
                padding: '5px 8px',
                borderRadius: '4px',
                marginTop: '5px',
                fontSize: '12px',
              }}
            >
              Show comparison dashboard
            </div>
          )}
        </div>
        {/* <PDFDownloadLink
        document={<PDFFile />}
        fileName="ticket.pdf"
      > */}
        {/* {({ loading }) =>
          loading ? (
            <button
              className={
                styles.findButton
              }
              type="button"
              onClick={() => {
                navigate('/PDFFile');
              }}
            >
              Reports
            </button>
          ) : (
            <button
              className={
                styles.findButton
              }
              type="button"
              onClick={() => {
                navigate('/PDFFile');
              }}
            >
              Download PDF
            </button>
          )
        } */}
        {/* </PDFDownloadLink> */}
        <div>
          <button
            className={styles.findButton}
            type="button"
            onClick={() => {
              navigate('/updatedReports');
            }}
          >
            <HiOutlineDocumentReport
              style={{
                marginRight: '8px',
                position: 'relative',
                top: '3px',
              }}
              size={'15px'}
            />
            Reports
          </button>
        </div>
      </div>
    </div>
  );
}
